import { render, staticRenderFns } from "./productselector.vue?vue&type=template&id=21c5e10e"
import script from "./productselector.vue?vue&type=script&lang=js"
export * from "./productselector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports